import { render, staticRenderFns } from "./baseRoleFieldModal.vue?vue&type=template&id=4ab26a3c&scoped=true"
import script from "./baseRoleFieldModal.vue?vue&type=script&lang=js"
export * from "./baseRoleFieldModal.vue?vue&type=script&lang=js"
import style0 from "./baseRoleFieldModal.vue?vue&type=style&index=0&id=4ab26a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab26a3c",
  null
  
)

export default component.exports